export const POLICY_HEADERS = ['CancellationPolicy', 'DepositPolicy', 'GuaranteePolicy'];

const HEADER_LABELS = {
  CancellationPolicy: 'Cancellation',
  DepositPolicy: 'Deposit',
  GuaranteePolicy: 'Guarantee',
  SafetyInfo: 'Safety info',
  TransportationInfo: 'Getting there',
};

export function label(header) {
  return HEADER_LABELS[header] || header;
}

/* ── Amenity detectors ── */
export const AMENITY_DETECTORS = [
  {
    keywords: ['outdoor pool', 'swimming pool'],
    label: 'Outdoor pool',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 21.5c1.5 0 2.5-.75 4-.75s2.5.75 4 .75 2.5-.75 4-.75 2.5.75 4 .75V20c-1.5 0-2.5-.75-4-.75S11.5 20 10 20s-2.5-.75-4-.75S3.5 20 2 20v1.5zm0-3.5c1.5 0 2.5-.75 4-.75s2.5.75 4 .75 2.5-.75 4-.75 2.5.75 4 .75v-1.5c-1.5 0-2.5-.75-4-.75s-2.5.75-4 .75-2.5-.75-4-.75-2.5.75-4 .75V18zM16.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM3 13.5l4-4 3 3 4-4 4 3V10H3v3.5z"/></svg>`,
  },
  {
    keywords: ['fitness room', 'fitness center', 'health club', 'gym', 'exercise gym', 'cardio'],
    label: 'Fitness centre',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"/></svg>`,
  },
  {
    keywords: ['wifi', 'wi-fi', 'wireless internet', 'high speed wifi', 'complimentary wireless'],
    label: 'WiFi',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1 9l2 2c5.52-5.52 14.48-5.52 20 0l2-2C19.93 3.45 11.54 2.1 5.12 5.15L1 9zm8 8l3 3 3-3a4.237 4.237 0 0 0-6 0zm-4-4l2 2a7.074 7.074 0 0 1 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/></svg>`,
  },
  {
    keywords: ['buffet breakfast', 'complimentary breakfast', 'breakfast'],
    label: 'Buffet breakfast',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.5 3H6c-1.1 0-2 .9-2 2v5.71c0 3.83 2.95 7.18 6.78 7.29 3.96.12 7.22-3.06 7.22-7v-1h.5c1.93 0 3.5-1.57 3.5-3.5S20.43 3 18.5 3zm0 5H17V5h1.5c.83 0 1.5.67 1.5 1.5S19.33 8 18.5 8zM4 19h16v2H4v-2z"/></svg>`,
  },
  {
    keywords: ['room service', '24 hour room service', '24-hour room service'],
    label: '24-hour room service',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11 3L9.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-5.17L13 3h-2zm1 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1.5c.83 0 1.5-.67 1.5-1.5v-2.5H12v2H10.5C10.5 16.33 11.17 17 12 17zm-1-4h2V9h-2v4z"/></svg>`,
  },
  {
    keywords: ['restaurant', 'dining'],
    label: 'On-site restaurant',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/></svg>`,
  },
  {
    keywords: ['rooftop bar', 'roof bar', 'pool bar', 'cocktail'],
    label: 'Bar',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 3H4v2l8 9v5H6v2h12v-2h-6v-5l8-9V3zm-2.53 2L12 12.39 6.53 5h10.94z"/></svg>`,
  },
  {
    keywords: ['meeting room', 'conference', 'event space'],
    label: 'Meeting rooms',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>`,
  },
  {
    keywords: ['solarium'],
    label: 'Solarium',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"/></svg>`,
  },
  {
    keywords: ['24-hour front desk', '24 hour front desk', 'front desk'],
    label: '24-hour front desk',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm4.5 14L11 9.5V4h1.5v4.75l5 5.25-1 1z"/></svg>`,
  },
  {
    keywords: ['daily housekeeping', 'housekeeping'],
    label: 'Daily housekeeping',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21 11.01L3 11v2h18v-1.99zM3 16h12v2H3v-2zM21 6H3v2.01L21 8V6z"/></svg>`,
  },
  {
    keywords: ['guest laundry', 'laundry'],
    label: 'Guest laundry',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9.17 16.83a4 4 0 0 0 5.66 0 4 4 0 0 0 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"/></svg>`,
  },
  {
    keywords: ['smoke-free', 'smoke free', 'non-smoking', 'non smoking'],
    label: 'Smoke-free property',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 6l6.99 7H3v2h8.99l7 7 1.26-1.25-16-16L2 6zm18 7h-2v2h2v-2zm0-7.42V3.5C16.85 3.5 14.5 5.82 14.5 8.71c0 1.28.49 2.44 1.29 3.33l1.41-1.41A2.716 2.716 0 0 1 16.5 8.7c0-1.54 1.26-2.83 2.82-2.83h1.18V4.58zm2.5 4.92h-2v2h2v-2z"/></svg>`,
  },
  {
    keywords: ['theatre', 'theater', 'amphitheatre'],
    label: 'Theatre',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 3C6.48 3 2 5.69 2 9v12l4-4h14l4 4V9c0-3.31-4.48-6-12-6zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>`,
  },
  {
    keywords: ['air conditioning', 'air-conditioned', 'air conditioned'],
    label: 'Air conditioning',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22v-2z"/></svg>`,
  },
  {
    keywords: ['wake-up call', 'wake up call', 'wakeup call'],
    label: 'Wake-up calls',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg>`,
  },
  {
    keywords: ['elevator', 'lift'],
    label: 'Elevators',
    icon: `<svg class="sat-amenity-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 11l5-5 5 5H7zm10 2l-5 5-5-5h10z"/></svg>`,
  },
];

/**
 * Returns amenities found in the hotel data.
 * @param {{ shortDescription: string, sections: Array<{header:string, html:string}> }} data
 * @returns {Array<{label:string, icon:string}>}
 */
export function detectAmenities(data) {
  const EXCLUDE = ['Attractions', 'TransportationInfo'];
  const allText = [
    data.shortDescription,
    ...data.sections.filter((s) => !EXCLUDE.includes(s.header)).map((s) => s.html),
  ]
    .join(' ')
    .toLowerCase();
  return AMENITY_DETECTORS.filter((a) => a.keywords.some((kw) => allText.includes(kw)));
}

/* ── Section content normalizer ── */
export function normalizeSection(html) {
  const lines = html.split(/<br\s*\/?>/i).flatMap((raw) => {
    const line = raw.trim();
    const dc = line.match(/^(.+?)\s{3,}(-\s*.+)$/);
    if (dc) return [dc[1].trim(), dc[2].trim()];
    return [line.replace(/ {2,}/g, ' ')];
  });

  function isComplete(line) {
    if (!line) return true;
    if (/^[-*•]/.test(line)) return true;
    if (/[.!?]\s*$/.test(line)) return true;
    if (/\d[\d.]*\s*[MKmk]+\s*$/.test(line)) return true;
    if (line.length > 2 && line === line.toUpperCase()) return true;
    return false;
  }

  function startsBlock(line) {
    if (!line) return true;
    if (/^[-*•]/.test(line)) return true;
    if (line.length > 2 && line === line.toUpperCase()) return true;
    return false;
  }

  const merged = [];
  for (const line of lines) {
    const prev = merged[merged.length - 1];
    if (prev !== undefined && !isComplete(prev) && !startsBlock(line) && line) {
      merged[merged.length - 1] = prev + ' ' + line;
    } else {
      merged.push(line);
    }
  }

  return merged.join('<br />').replace(/(\w)\/\s*(\w)/g, '$1, $2');
}

/* ── Short description processor ── */
export function renderShortDesc(html) {
  let out = html;
  out = out.replace(/<br\s*\/?>/gi, ' ');
  out = out.replace(/^[A-Z][A-Z\s]+?(?=\s+[A-Z][a-z])/, '');
  out = out.replace(/\s\/([^/\n]{1,60}?)\//g, ' ($1)');
  out = out.replace(/(\w)\/\s*(\w)/g, '$1, $2');
  out = out.replace(/\s{2,}/g, ' ').trim();
  return out;
}

/* ── Section renderers — all return HTML strings ── */

/** Name, distance number, unit (mi/miles/km/k/m), optional compass (KM SW style from Sabre). */
const ATTRACTION_DIST_RE =
  /^(.+?)\s+([\d.]+)\s*(miles?|mi|km|k|m)\b(?:\s+(NE|NW|N|SE|SW|S|E|W))?\s*$/i;

export function renderAttractions(html) {
  const rows = html
    .split(/<br\s*\/?>/i)
    .map((raw) => raw.trim())
    .filter(Boolean)
    .map((line) => {
      const m = line.match(ATTRACTION_DIST_RE);
      if (!m)
        return `<div class="sat-attraction-row"><span class="sat-attraction-name">${line}</span></div>`;
      const name = m[1].trim();
      const dist = parseFloat(m[2]);
      const unit = m[3].toLowerCase();
      const bearing = m[4] ? m[4].toUpperCase() : '';
      let distLabel;
      if (unit === 'mi' || unit === 'mile' || unit === 'miles') {
        distLabel = dist + ' mi';
      } else if (unit === 'km' || unit === 'k') {
        distLabel = dist + ' km';
      } else if (unit === 'm' && dist >= 1000) {
        distLabel = (dist / 1000).toFixed(1).replace(/\.0$/, '') + ' km';
      } else {
        distLabel = Math.round(dist) + ' m';
      }
      if (bearing) {
        distLabel += ' ' + bearing;
      }
      const cleanName = name.replace(/(\w)\/(\w)/g, '$1, $2');
      return `<div class="sat-attraction-row"><span class="sat-attraction-name">${cleanName}</span><span class="sat-attraction-dist">${distLabel}</span></div>`;
    });
  return `<div class="sat-attractions-list">${rows.join('')}</div>`;
}

function stripDiningStr(s) {
  if (!s) return '';
  return s
    .replace(/\uFFFD/g, '')
    .replace(/\u00A0/g, ' ')
    .replace(/^Description:\s*/i, '')
    .trim();
}

/** Sabre often sends Attire/Cuisine/Meals/Description on one line; split before each keyword. */
function splitInlineDiningFields(line) {
  const s = stripDiningStr(line);
  if (!s || s.length < 24) return [s];
  const keywords = (
    s.match(/\b(?:Attire|Cuisine|Meals\s+served|Restaurant\s+description)\b/gi) || []
  ).length;
  if (keywords < 2) return [s];
  return s
    .split(/\s+(?=(?:Attire|Cuisine|Meals\s+served|Restaurant\s+description)\b)/i)
    .map((x) => stripDiningStr(x))
    .filter(Boolean);
}

function expandDiningLines(lines) {
  return lines.flatMap(splitInlineDiningFields);
}

function parseDiningDetails(restLines) {
  const details = [];
  const descParts = [];
  let inDesc = false;

  for (const raw of expandDiningLines(restLines.map(stripDiningStr))) {
    const line = stripDiningStr(raw);
    if (!line) continue;

    let m = line.match(/^attire\s*[-–—]\s*(.+)$/i);
    if (m) {
      details.push({ label: 'Attire', value: m[1].trim() });
      continue;
    }
    m = line.match(/^cuisine\s*[-–—]\s*(.+)$/i);
    if (m) {
      details.push({ label: 'Cuisine', value: m[1].trim() });
      continue;
    }
    m = line.match(/^meals served\s*[-–—]\s*(.+)$/i);
    if (m) {
      const val = m[1].trim().replace(/\s*[-–—]\s*/g, ', ');
      details.push({ label: 'Meals served', value: val });
      continue;
    }
    m = line.match(/^restaurant description\s*[:\-–—]?\s*(.*)$/i);
    if (m) {
      inDesc = true;
      if (m[1].trim()) descParts.push(m[1].trim());
      continue;
    }
    if (inDesc) {
      descParts.push(line);
    } else {
      details.push({ label: '', value: line });
    }
  }

  const desc = descParts.join(' ').trim() || null;
  return { details, desc };
}

function addDiningVenue(lines, items) {
  if (!lines.length) return;
  const name = stripDiningStr(lines[0].replace(/^Description:\s*/i, ''));
  let rest = lines
    .slice(1)
    .map((l) => stripDiningStr(l.replace(/^Description:\s*/i, '')))
    .filter(Boolean);

  const servIdx = rest.findIndex((l) => /^serving\b/i.test(l));
  let meta = null;
  if (servIdx >= 0) {
    meta = rest
      .splice(servIdx, 1)[0]
      .replace(/^serving\s*/i, '')
      .split(/,\s*/)
      .join(' · ');
  }

  const hoursIdx = rest.findIndex((l) => /^hours$/i.test(l));
  if (hoursIdx >= 0) rest.splice(hoursIdx, 1);

  const { details, desc: parsedDesc } = parseDiningDetails(rest);
  let detailsOut = details.filter((d) => d.value);
  let desc = parsedDesc;

  if (detailsOut.length === 0 && !desc) {
    if (!meta && rest.length === 1 && rest[0].length < 70) {
      meta = rest[0];
    } else {
      desc = rest.join(' ').trim() || null;
    }
    detailsOut = [];
  }

  items.push({ type: 'venue', name, desc, meta, details: detailsOut });
}

function diningSectionLabelFromLine(first) {
  return first
    .replace(/^-+\s*/, '')
    .replace(/:$/, '')
    .replace(/\s*[-–—]\s*$/, '')
    .trim();
}

export function renderDining(html) {
  const norm = html.replace(/(\w)\/\s*(\w)/g, '$1, $2');
  const blocks = norm.split(/<br\s*\/?>\s*<br\s*\/?>/i);
  const items = [];

  for (const block of blocks) {
    const lines = block
      .split(/<br\s*\/?>/i)
      .map((l) => l.replace(/<[^>]+>/g, '').trim())
      .map((l) => stripDiningStr(l))
      .filter(Boolean);
    if (!lines.length) continue;

    const first = lines[0];
    const isSectionMarker =
      /^-+\s*(on.?site|off.?site|on.?property|off.?property)/i.test(first) ||
      (first === first.toUpperCase() &&
        first.length > 2 &&
        (first.endsWith(':') || /[-–—]\s*$/.test(first))) ||
      /^(restaurants?|bars?|cafes?|lounges?|dining)\s*[-–—:]*\s*$/i.test(first.trim());

    if (isSectionMarker) {
      items.push({
        type: 'section',
        label: diningSectionLabelFromLine(first),
      });
      if (lines.length > 1) addDiningVenue(lines.slice(1), items);
      continue;
    }
    addDiningVenue(lines, items);
  }

  if (!items.length) return '';

  const rows = items
    .map((item) => {
      if (item.type === 'section') {
        return `<div class="sat-dining-label">${item.label}</div>`;
      }
      const { name, desc, meta, details } = item;
      const detailBlock =
        details && details.length
          ? `<div class="sat-dining-venue-details">${details
              .map((d) => {
                if (d.label) {
                  return `<div class="sat-dining-venue-detail"><span class="sat-dining-venue-detail-label">${d.label}:</span> <span class="sat-dining-venue-detail-value">${d.value}</span></div>`;
                }
                return `<div class="sat-dining-venue-detail sat-dining-venue-detail--plain">${d.value}</div>`;
              })
              .join('')}</div>`
          : '';

      if (!desc && !meta && !detailBlock) {
        return `<div class="sat-dining-venue"><span class="sat-dining-venue-name">${name}</span></div>`;
      }
      if (!desc && meta && !detailBlock) {
        return `<div class="sat-dining-venue sat-dining-venue--compact"><span class="sat-dining-venue-name">${name}</span><span class="sat-dining-venue-cuisine">${meta}</span></div>`;
      }
      return `<div class="sat-dining-venue">
      <div class="sat-dining-venue-name">${name}</div>
      ${detailBlock}
      ${meta ? `<div class="sat-dining-venue-meta">${meta}</div>` : ''}
      ${desc ? `<div class="sat-dining-venue-desc">${desc}</div>` : ''}
    </div>`;
    })
    .join('');

  return `<div>${rows}</div>`;
}

function stripFacilitiesStr(s) {
  if (!s) return '';
  return s
    .replace(/\uFFFD/g, '')
    .replace(/\u00A0/g, ' ')
    .trim();
}

/** Sabre sends empty stubs like "On-Site Facilities Description -" — turn into a short heading. */
function humanizeFacilitiesSectionLine(line) {
  const t = stripFacilitiesStr(line).replace(/^-+\s*/, '');
  if (/^on-?site\s+facilities(?:\s+description)?\s*[-–—:.\s]*$/i.test(t))
    return 'On-site facilities';
  if (/^off-?site\s+facilities(?:\s+description)?\s*[-–—:.\s]*$/i.test(t))
    return 'Off-site facilities';
  if (/^meeting and convention facilities\s*[-–—:.\s]*$/i.test(t))
    return 'Meeting and convention facilities';
  if (/^meeting room size and seating format options\s*[-–—:.\s]*$/i.test(t))
    return 'Meeting room sizes and seating';
  return null;
}

/** Collapse accidental `Banquet:: 60` from chained normalizers. */
function collapseDuplicateColons(s) {
  let t = s;
  while (/:\s*:/.test(t)) {
    t = t.replace(/:\s*:/g, ':');
  }
  return t;
}

/** "Label -: 12" / "Label - 470 SQ M" → "Label: …" */
function normalizeFacilitiesKeyValue(s) {
  const x = stripFacilitiesStr(s);
  if (!x) return '';
  let m = x.match(/^(.+?)\s*[-–—]\s*:\s*(.+)$/);
  if (m)
    return collapseDuplicateColons(`${m[1].trim().replace(/\s*[-–—]\s*$/, '')}: ${m[2].trim()}`);
  m = x.match(/^(.+?)\s[-–—]\s+(.+)$/);
  if (m) {
    const label = m[1].trim();
    const val = m[2].trim();
    if (
      /\d/.test(val) ||
      /\b(SQ\s*M|EUR|USD|capacity|rooms?)\b/i.test(val) ||
      (val.length <= 48 && /^[A-Z0-9]/.test(val))
    ) {
      return collapseDuplicateColons(`${label}: ${val}`);
    }
  }
  return collapseDuplicateColons(x);
}

/** "coffee Direct dial" → two items when Sabre omits line breaks */
function splitMergedFacilityPhrases(s) {
  if (s.length < 28 || /:\s*\d/.test(s)) return [s];
  const parts = s.split(/(?<=[a-z,.])\s+(?=[A-Z][a-z]+(?:\s+[a-z]+){0,4}\s*$)/);
  if (parts.length > 1) return parts.map((p) => p.trim()).filter(Boolean);
  const parts2 = s.split(/(?<=[a-z,.])\s+(?=[A-Z][a-z]+\s+[a-z])/);
  return parts2.length > 1 ? parts2.map((p) => p.trim()).filter(Boolean) : [s];
}

function facilitiesKvFormat(s) {
  const trailing = s.match(/^(.+?)\s+(\d+)\s*$/);
  if (trailing) {
    const lab = trailing[1].trim().replace(/:+\s*$/, '');
    return collapseDuplicateColons(`${lab}: ${trailing[2]}`);
  }
  const leading = s.match(/^(\d+)\s+(.+[s)])\s*$/);
  if (leading) return collapseDuplicateColons(`${leading[2].trim()}: ${leading[1]}`);
  return s;
}

function prettifyFacilitiesLine(line) {
  let s = stripFacilitiesStr(line.replace(/^-+\s*/, ''));
  s = normalizeFacilitiesKeyValue(s);
  s = facilitiesKvFormat(s);
  if (!s) return [];
  s = s.replace(/^Meeting Room Name\s*[-–—]\s*/i, '');
  s = s.replace(/\s+i$/i, '');
  if (humanizeFacilitiesSectionLine(s)) return [];
  s = collapseDuplicateColons(s);
  return splitMergedFacilityPhrases(s);
}

/** "Meeting Room Name: Studio 1" / "Meeting Room Name - Ballroom" → room name only */
function parseMeetingRoomNameLine(raw) {
  const t = stripFacilitiesStr(raw);
  const m =
    t.match(/^Meeting\s+Room\s+Name\s*:\s*(.+)$/i) ||
    t.match(/^Meeting\s+Room\s+Name\s*[-–—]\s*(.+)$/i);
  return m ? m[1].trim() : null;
}

export function renderFacilities(html) {
  const blocks = html.split(/<br\s*\/?>\s*<br\s*\/?>/i);
  /** @type {Array<{ type: 'section' | 'item' | 'meetingHead'; text?: string; wide?: boolean }>} */
  const out = [];

  function pushSection(text) {
    if (out.length && out[out.length - 1].type === 'section' && out[out.length - 1].text === text)
      return;
    out.push({ type: 'section', text });
  }

  function pushMeetingRoomHeader(name) {
    out.push({ type: 'meetingHead', text: name });
  }

  function pushItem(text) {
    const t = collapseDuplicateColons(stripFacilitiesStr(text));
    if (!t || humanizeFacilitiesSectionLine(t)) return;
    const wide = t.length > 130 && !/^[^:]{1,80}:\s*\S/.test(t);
    out.push({ type: 'item', text: t, wide });
  }

  for (const block of blocks) {
    let rawLines = block
      .split(/<br\s*\/?>/i)
      .map((l) => stripFacilitiesStr(l))
      .filter(Boolean);
    if (!rawLines.length) continue;

    const sec0 = humanizeFacilitiesSectionLine(rawLines[0]);
    if (sec0) {
      pushSection(sec0);
      rawLines = rawLines.slice(1);
    }
    if (!rawLines.length) continue;

    const merged = rawLines.join(' ');
    if ((merged.match(/\w\/\w/g) || []).length >= 2) {
      merged
        .split(/\/\s*/)
        .map((s) => facilitiesKvFormat(s.trim()))
        .filter(Boolean)
        .forEach((s) => prettifyFacilitiesLine(s).forEach((p) => pushItem(p)));
      continue;
    }

    const lines = rawLines
      .flatMap((raw) => {
        const line = raw.replace(/^-+\s*/, '').trim();
        const dc = line.match(/^(.+?)\s{3,}(\S.*)$/);
        if (dc) return [dc[1].trim(), dc[2].replace(/^-+\s*/, '').trim()].filter(Boolean);
        return [line];
      })
      .filter(Boolean);

    for (const line of lines) {
      const inlineSec = humanizeFacilitiesSectionLine(line);
      if (inlineSec) {
        pushSection(inlineSec);
        continue;
      }
      const roomName = parseMeetingRoomNameLine(line);
      if (roomName !== null) {
        pushMeetingRoomHeader(roomName);
        continue;
      }
      prettifyFacilitiesLine(line).forEach((p) => pushItem(p));
    }
  }

  if (!out.length) return '';
  const cells = out.map((o) => {
    if (o.type === 'section') {
      return `<div class="sat-fac-section">${o.text}</div>`;
    }
    if (o.type === 'meetingHead') {
      return `<div class="sat-fac-meeting-name">${o.text}</div>`;
    }
    return `<div class="sat-fac-item${o.wide ? ' sat-fac-item--wide' : ''}">${o.text}</div>`;
  });
  return `<div class="sat-fac-grid">${cells.join('')}</div>`;
}

export function renderSafetyInfo(html) {
  const items = [];
  for (const block of html.split(/<br\s*\/?>\s*<br\s*\/?>/i)) {
    block
      .split(/<br\s*\/?>/i)
      .flatMap((raw) => {
        const line = raw.replace(/^-+\s*/, '').trim();
        const dc = line.match(/^(.+?)\s{3,}(\S.*)$/);
        if (dc) return [dc[1].trim(), dc[2].replace(/^-+\s*/, '').trim()].filter(Boolean);
        return [line];
      })
      .filter(Boolean)
      .forEach((s) => items.push(s));
  }
  if (!items.length) return '';
  return `<div class="sat-saf-grid">${items.map((t) => `<div class="sat-saf-item">${t}</div>`).join('')}</div>`;
}

export function renderServices(html) {
  const entries = [];

  for (const block of html.split(/<br\s*\/?>\s*<br\s*\/?>/i)) {
    const rawLines = block
      .split(/<br\s*\/?>/i)
      .map((l) => l.trim())
      .filter(Boolean);
    if (!rawLines.length) continue;

    const first = rawLines[0];
    const boldLabel = first.match(/^\*\*(.+?)\*\*$/);
    if (boldLabel) {
      entries.push({ type: 'label', text: boldLabel[1].trim() });
      rawLines.slice(1).forEach((l) => {
        const c = l.replace(/^-+\s*/, '').trim();
        if (c) entries.push({ type: 'item', text: c });
      });
      continue;
    }

    const merged = rawLines.join(' ');
    if ((merged.match(/\w\/\w/g) || []).length >= 2) {
      merged
        .split(/\/\s*/)
        .map((s) => s.trim())
        .filter(Boolean)
        .forEach((s) => entries.push({ type: 'item', text: s }));
      continue;
    }

    rawLines
      .flatMap((raw) => {
        const line = raw.replace(/^-+\s*/, '').trim();
        const dc = line.match(/^(.+?)\s{3,}(\S.*)$/);
        if (dc) return [dc[1].trim(), dc[2].replace(/^-+\s*/, '').trim()].filter(Boolean);
        return [line];
      })
      .filter(Boolean)
      .forEach((s) => entries.push({ type: 'item', text: s }));
  }

  if (!entries.length) return '';

  const out = [];
  let pending = [];
  function flush() {
    if (pending.length) {
      out.push(
        `<div class="sat-svc-grid">${pending.map((t) => `<div class="sat-svc-item">${t}</div>`).join('')}</div>`,
      );
      pending = [];
    }
  }
  for (const e of entries) {
    if (e.type === 'label') {
      flush();
      out.push(
        `<div class="sat-dining-label"${out.length ? ' style="margin-top:.85rem"' : ''}>${e.text}</div>`,
      );
    } else {
      pending.push(e.text);
    }
  }
  flush();
  return `<div>${out.join('')}</div>`;
}

export function renderTransportationInfo(html) {
  const out = [];

  for (const block of html.split(/<br\s*\/?>\s*<br\s*\/?>/i)) {
    const rawLines = block
      .split(/<br\s*\/?>/i)
      .map((l) => l.trim())
      .filter(Boolean);
    if (!rawLines.length) continue;

    const first = rawLines[0];
    const allText = rawLines.join(' ');

    const isTransitKV =
      rawLines.length >= 3 &&
      /metro|station|transit|bus|subway/i.test(allText) &&
      !/^[A-Z]{2,3}\s*[-–]/.test(first);

    if (isTransitKV) {
      const name = rawLines
        .map((l) => l.match(/(?:station|stop|metro)\s+([A-Z][A-Z0-9]+)\s*$/i)?.[1])
        .find(Boolean);
      const dist = rawLines.map((l) => l.match(/distance.+?(\d+)\s*$/i)?.[1]).find(Boolean);
      const adj = rawLines.some((l) => /adjacent/i.test(l));
      const parts = [
        name ? `Station: ${name}` : null,
        dist ? `${dist} m away` : null,
        adj ? 'Public transport adjacent' : null,
      ].filter(Boolean);
      if (parts.length) {
        out.push(
          `<div class="sat-trans-block"><div class="sat-trans-label">Local transit</div><div class="sat-trans-body">${parts.join(' · ')}</div></div>`,
        );
      }
      continue;
    }

    const lbl = first.replace(/(\w)\/\s*(\w)/g, '$1, $2');
    const body = rawLines
      .slice(1)
      .join(' ')
      .replace(/(\w)\/\s*(\w)/g, '$1, $2')
      .replace(/\s{2,}/g, ' ')
      .trim();

    out.push(
      `<div class="sat-trans-block"><div class="sat-trans-label">${lbl}</div>${body ? `<div class="sat-trans-body">${body}</div>` : ''}</div>`,
    );
  }

  return out.length ? `<div>${out.join('')}</div>` : '';
}

export function renderRecreation(html) {
  const entries = [];

  function isLabel(line) {
    return /\b(on.?site|off.?site)\b/i.test(line) || /^recreation/i.test(line);
  }

  for (const block of html.split(/<br\s*\/?>\s*<br\s*\/?>/i)) {
    const rawLines = block
      .split(/<br\s*\/?>/i)
      .map((l) => l.trim())
      .filter(Boolean);
    if (!rawLines.length) continue;

    const first = rawLines[0].replace(/^-+\s*/, '');

    if (isLabel(first)) {
      entries.push({ type: 'label', text: first });
      rawLines.slice(1).forEach((l) => {
        const clean = l.replace(/^-+\s*/, '').trim();
        if (clean) entries.push({ type: 'item', text: clean });
      });
      continue;
    }

    const merged = rawLines.join(' ');
    if ((merged.match(/\w\/\w/g) || []).length >= 2) {
      merged
        .split(/\/\s*/)
        .map((s) => s.trim())
        .filter(Boolean)
        .forEach((s) => entries.push({ type: 'item', text: s }));
      continue;
    }

    rawLines
      .flatMap((raw) => {
        const line = raw.replace(/^-+\s*/, '').trim();
        const dc = line.match(/^(.+?)\s{3,}(\S.*)$/);
        if (dc) return [dc[1].trim(), dc[2].replace(/^-+\s*/, '').trim()].filter(Boolean);
        return [line];
      })
      .filter(Boolean)
      .forEach((s) => entries.push({ type: 'item', text: s }));
  }

  if (!entries.length) return '';

  const out = [];
  let pending = [];

  function flush() {
    if (pending.length) {
      out.push(
        `<div class="sat-rec-grid">${pending.map((t) => `<div class="sat-rec-item">${t}</div>`).join('')}</div>`,
      );
      pending = [];
    }
  }

  for (const e of entries) {
    if (e.type === 'label') {
      flush();
      out.push(
        `<div class="sat-dining-label"${out.length ? ' style="margin-top:.85rem"' : ''}>${e.text}</div>`,
      );
    } else {
      pending.push(e.text);
    }
  }
  flush();

  return `<div>${out.join('')}</div>`;
}

const SABRE_MON = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
};

/** Sabre often sends ddmonyy (e.g. 11mar22); decode to a short English date string. */
function formatSabreDateToken(token) {
  const m = String(token).match(/^(\d{1,2})([a-z]{3})(\d{2})$/i);
  if (!m) return token;
  const day = parseInt(m[1], 10);
  const mon = SABRE_MON[m[2].toLowerCase()];
  if (mon === undefined) return token;
  let y = parseInt(m[3], 10);
  y = y >= 70 ? 1900 + y : 2000 + y;
  const d = new Date(y, mon, day);
  if (Number.isNaN(d.getTime())) return token;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * Cleans Sabre "Things to know" lines: cryptic date ranges, stray hyphens, DAY(S) wording.
 */
function prettifyThingsToKnowLine(line) {
  let s = line.trim();
  if (!s) return s;

  s = s.replace(/^[\s\-–—.:]+/, '');

  s = s.replace(/\b1\s+DAYS\b/gi, '1 day');
  s = s.replace(/\b(\d+)\s+DAYS\b/gi, (_, n) => {
    const k = parseInt(n, 10);
    return `${n} ${k === 1 ? 'day' : 'days'}`;
  });

  s = s.replace(
    /\b(\d{1,2}[a-z]{3}\d{2})\s*[-–]\s*(\d{1,2}[a-z]{3}\d{2})\b/gi,
    (_, a, b) => `${formatSabreDateToken(a)} – ${formatSabreDateToken(b)}`,
  );
  s = s.replace(
    /\b(\d{1,2}[a-z]{3}\d{2})-(\d{1,2}[a-z]{3}\d{2})\b/gi,
    (_, a, b) => `${formatSabreDateToken(a)} – ${formatSabreDateToken(b)}`,
  );
  s = s.replace(/\b(\d{1,2}[a-z]{3}\d{2})\b/gi, (_, t) => formatSabreDateToken(t));

  s = s.replace(/^([A-Za-z][A-Za-z\s]{2,72}?)-\s+(?=[^\s])/i, '$1 — ');

  s = s.replace(/\s{2,}/g, ' ').trim();
  return s;
}

function rawPolicyPlainLength(html) {
  if (!html) return 0;
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim().length;
}

/**
 * When any cancellation/deposit/guarantee column is long, collapse all three so Show more/less stays aligned.
 */
export function thingsToKnowShouldCollapseAllColumns(sections) {
  if (!sections || !sections.length) return false;
  return sections.some((s) => {
    const raw = s.html || '';
    return raw.length > 200 || rawPolicyPlainLength(raw) > 85;
  });
}

export function renderPolicyText(html) {
  const normalized = normalizeSection(html);
  const lines = normalized.split(/<br\s*\/?>/i).map((line) => {
    const t = line.trim();
    if (t.length > 3 && t === t.toUpperCase() && /[A-Z]/.test(t)) {
      return prettifyThingsToKnowLine(t.charAt(0) + t.slice(1).toLowerCase());
    }
    return prettifyThingsToKnowLine(t);
  });
  return `<div class="sat-things-content">${lines.filter(Boolean).join('<br />')}</div>`;
}

export function renderCommission(commHtml, doShow = true) {
  if (!doShow) return '';

  const inner = commHtml
    .replace(/<div[^>]*id=['"]hotelCommission['"][^>]*>/i, '')
    .replace(/<\/div>\s*$/i, '');

  const lines = inner
    .split(/<br\s*\/?>/i)
    .map((l) => l.replace(/<[^>]+>/g, '').trim())
    .filter(Boolean);

  let start = 0;
  if (lines[0] && /commission.*(policy)?/i.test(lines[0])) start = 1;

  let percent = null;
  const bodyLines = [];
  for (const line of lines.slice(start)) {
    const pct = line.match(/-?\s*commission\s+percent\s*-\s*(\d+)/i);
    if (pct) {
      percent = pct[1];
      continue;
    }
    if (line === line.toUpperCase()) continue;
    bodyLines.push(line);
  }

  const desc = bodyLines
    .join(' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  return `<div class="sat-pol-comm">
    <div class="sat-pol-comm-label">Commission${percent ? `: ${percent}%` : ''}</div>
    ${desc ? `<div class="sat-pol-comm-desc">${desc}</div>` : ''}
  </div>`;
}

export function renderPolicies(html, doShowCommission = true) {
  const commIdx = html.search(/<div[^>]*id=['"]hotelCommission['"]/i);
  const commHtml = commIdx >= 0 ? html.slice(commIdx) : '';
  const mainHtml = commIdx >= 0 ? html.slice(0, commIdx) : html;

  function isTitleLine(line) {
    if (line.includes('.')) return false;
    if (/\b(policy|policies|conditions?)\b/i.test(line)) return true;
    if (/^-\s*[A-Z][A-Z\s]+$/.test(line)) return true;
    return false;
  }

  const items = [];

  for (const para of mainHtml.split(/<br\s*\/?>\s*<br\s*\/?>/i)) {
    const lines = para
      .split(/<br\s*\/?>/i)
      .map((l) => l.replace(/<[^>]+>/g, '').trim())
      .filter(Boolean);
    if (!lines.length) continue;
    if (/^-?\s*meal\s*plan/i.test(lines[0])) continue;

    let current = null;

    for (const line of lines) {
      const inline = !line.startsWith('-') && line.match(/^([\w][^-]{1,30}?)\s+-\s+(.+)$/);
      if (inline) {
        current = { name: inline[1].trim(), body: inline[2].trim() };
        items.push(current);
        continue;
      }
      if (isTitleLine(line)) {
        current = { name: line.replace(/^-+\s*/, '').trim(), body: '' };
        items.push(current);
        continue;
      }
      if (!current) {
        current = { name: '', body: '' };
        items.push(current);
      }
      current.body = current.body ? current.body + ' ' + line : line;
    }
  }

  const rows = items
    .filter(({ name, body }) => name || body.length > 15)
    .map(
      ({ name, body }) => `
      <div class="sat-pol-item">
        ${name ? `<div class="sat-pol-name">${name}</div>` : ''}
        ${body ? `<div class="sat-pol-body">${body}</div>` : ''}
      </div>`,
    )
    .join('');

  if (!rows && !commHtml) return '';

  return `<div>
    ${rows}
    ${commHtml ? renderCommission(commHtml, doShowCommission) : ''}
  </div>`;
}
